import gql from 'graphql-tag'
import { EnumFields } from '..'

export const FinancialCategoryFragment = gql`
  fragment FinancialCategory on finance_financial_category{
    ${EnumFields}
  }
`
